import { setShowClientContactModal } from '../State/showClientContactModal';
import { loadClientContactForEdit } from '../State/clientConactForEdit';

export default (record) => async (dispatch) => {
  
  dispatch(loadClientContactForEdit(record));
  dispatch(setShowClientContactModal(true))
    
}